export const apiLanguages = JSON.parse(localStorage.getItem("langs-details")) || [];

export const apiLanguage = JSON.parse(localStorage.getItem("api-lang")) || false;

export const apiLanguageCodes = Object.keys(apiLanguages);

export default class LanguageApi {
  langDb = "panel_language";
  langStore = "translations";
  db = null;

  openDatabase() {
    return new Promise((resolve, reject) => {
      const request = window.indexedDB.open(this.langDb, 3);

      request.onerror = function(event) {
        reject("Veritabanı açılırken bir hata oluştu: " + event.target.errorCode);
      };

      request.onsuccess = event => {
        this.db = event.target.result;
        resolve();
      };

      request.onupgradeneeded = event => {
        this.db = event.target.result;
        this.createStore();
      };
    });
  }

  createStore() {
    if (!this.db.objectStoreNames.contains(this.langStore)) {
      this.db.createObjectStore(this.langStore);
    }
  }

  async setPanelLanguages(data) {
    if (!this.db) {
      await this.openDatabase();
    }

    return new Promise(async (resolve, reject) => {
      const transaction = this.db.transaction(this.langStore, "readwrite");
      const store = transaction.objectStore(this.langStore);

      for (const key in data) {
        const request = store.put(data[key], key);

        request.onsuccess = function(event) {
          console.log("Veri başarıyla eklendi.");
        };

        request.onerror = function(event) {
          console.log("Veri eklenirken bir hata oluştu:", event.target.errorCode);
        };
      }

      transaction.oncomplete = () => {
        console.log("Transaction tamamlandı.");
        resolve();
      };

      transaction.onerror = () => {
        reject("Transaction hatası.");
      };
    });
  }

  async getLanguageByKey(key) {
    if (!this.db) {
      await this.openDatabase();
    }

    return new Promise((resolve, reject) => {
      const store = this.db.transaction([this.langStore], "readonly")
        .objectStore(this.langStore);

      const request = store.get(key);

      request.onsuccess = function(event) {
        const data = event.target.result;
        resolve(data);
      };

      request.onerror = function(event) {
        reject("Veri alınırken bir hata oluştu:", event.target.errorCode);
      };
    });
  }

  async getAllLanguages() {
    if (!this.db) {
      await this.openDatabase();
    }

    return new Promise((resolve, reject) => {
      const store = this.db.transaction([this.langStore], "readonly")
        .objectStore(this.langStore);

      const request = store.openCursor();
      const result = {};

      request.onsuccess = function(event) {
        const cursor = event.target.result;

        if (cursor) {
          result[cursor.key] = cursor.value;
          cursor.continue();
        } else {
          resolve(result);
        }
      };

      request.onerror = function(event) {
        reject("Tüm veriler alınırken bir hata oluştu:", event.target.errorCode);
      };
    });
  }
}

// langDbRequest.onerror = (event) => {
//   console.error(event)
// };
//
// langDbRequest.onupgradeneeded = (event) => {
//   const db = event.target.result;
//
//   // Create an objectStore to hold information about our customers. We're
//   // going to use "ssn" as our key path because it's guaranteed to be
//   // unique - or at least that's what I was told during the kickoff meeting.
//   const objectStore = db.createObjectStore("customers", { keyPath: "ssn" });
//
//   // Create an index to search customers by name. We may have duplicates
//   // so we can't use a unique index.
//   objectStore.createIndex("name", "name", { unique: false });
//
//   // Create an index to search customers by email. We want to ensure that
//   // no two customers have the same email, so use a unique index.
//   objectStore.createIndex("email", "email", { unique: true });
//
//   // Use transaction oncomplete to make sure the objectStore creation is
//   // finished before adding data into it.
//   objectStore.transaction.oncomplete = (event) => {
//     // Store values in the newly created objectStore.
//     const customerObjectStore = db
//       .transaction("customers", "readwrite")
//       .objectStore("customers");
//     customerData.forEach((customer) => {
//       customerObjectStore.add(customer);
//     });
//   };
// };
